const plan_user = (state = null, action: any) => {
  switch (action.type) {
    case 'SET_PLAN_USER':
      return action.payload;
    default:
      return state;
  }
};

export default plan_user;
